import React, { useState, useContext, useCallback, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import { EditorPage, DisplayContext, IDisplay } from 'components/editor-page';
import { Login, UserContext } from 'components/login';
import _ from "lodash";
import { config } from 'config';
import { User } from 'data/user';

const ToDoItem = ({id, title, onChange} : { id: number, title: string, onChange: (id: number, title: string) => void }) => {
  const doOnChange = (ev: any) => onChange(id, ev.target.value);
  console.log('$render ' + id + ' title ' + title);
  return (
      <input value={title} onChange={doOnChange} />
  )
}

const App: React.FC = () => {
  const userStateUse = useState<User>(User.UncheckedUser());
  const displayStateUse = useState<IDisplay>({ showPane: false });
  const basename = config.rootPath;

  return (
    <UserContext.Provider value={userStateUse}>
    <DisplayContext.Provider value={displayStateUse}>
      <Router basename={basename}>
        <Switch>
          <Route path="/*">
            <SecuredArea />
          </Route>
        </Switch>
      </Router>
    </DisplayContext.Provider>
    </UserContext.Provider>
  );
}

function CheckUser() {
  const [user, setUser] = useContext(UserContext);
  if (user.isAnon()) {
    config.api.loggedInUser().then(u => {
      console.log(JSON.stringify(u)); 
      setUser(u);
    });
  }
  return (<></>);
}

function SecuredArea() {
  const [user, setUser] = useContext(UserContext);

  return (
  <>
    {user.isUnchecked
    ? <CheckUser />
    : (!user.isAnon()
      ? <RouteComponent user={user} setUser={setUser} />
      : <Login />)}
  </>
  );
}

interface IRouteComponentProps {
  user: User,
  setUser: (user: User) => void
}

function RouteComponent({user, setUser}: IRouteComponentProps) {
  const [ timeoutHandle, setTimeoutHandle ] = useState<NodeJS.Timeout | null>(null);
  const expiry = user.expiry;
  if (!expiry) throw "User has no expiry: " + JSON.stringify(user);

  // Retrigger check on valid user just after session should have timed out
  useEffect(() => {
    let timeToExpiryMs = expiry - (new Date().getTime());
    timeToExpiryMs = timeToExpiryMs > 0 ? timeToExpiryMs : 0;
    timeToExpiryMs += 1000;
    if (timeoutHandle) clearTimeout(timeoutHandle);
    setTimeoutHandle(setTimeout(() => setUser(User.AnonUser()), timeToExpiryMs))
  }, [ expiry ]);

  return <EditorPage/>;
}

export default App;
